import classNames from "classnames";
import Styles from "./Service.module.scss";
import Footer from "../../Component/Footer/Footer";
import Navbar from "../../Component/Navbar/Navbar";
import Card1 from "../../Component/Card/Card1";

import img1 from "../../assets/images/index/社工協助.jpg";
import img2 from "../../assets/images/index/交通接送.jpg";
import img3 from "../../assets/images/index/協助困境.jpg";
import img4 from "../../assets/images/index/幸福2-1.jpg";
import img5 from "../../assets/images/index/圓夢計畫-1.jpg";
import SubTitle from "../../Component/Text/SubTitle";
import { Link, useNavigate } from "react-router-dom";

const SocialService = () => {
  const navigate = useNavigate();



  return (
    <div>
      <Navbar />

      {/* main */}
      <div className={classNames("container")} style={{ paddingTop: "10vh" }}>
        <SubTitle text={`社會服務`} />
        <div className={classNames(Styles.service)} style={{ paddingTop: "2vh",paddingBottom: "5vh" }}>

          <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
            <div className={classNames(Styles.service__card)}>
              <Card1 img={img1} text={`短期臨托`} to={`短期臨托`} />
            </div>
          </div>

          <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
            <div className={classNames(Styles.service__card)}>

                <Card1 img={img2} text={`長照巴士預約`}  to={`長照巴士預約`} />
            </div>

          </div>
          <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
            <div className={classNames(Styles.service__card)}>

              <Card1 img={img3} text={`長照居家\n困境協助`} to={`長照居家困境協助`}/>
            </div>

          </div>
        </div>

        {/* 幸福二之一、偏向身障圓夢計畫 */}
        {/* <div className={classNames(Styles.service)}>
          <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
            <div className={classNames(Styles.service__card)}>
              <Card1 img={img4} text={`幸福二之一`} to={`幸福二之一`}/>
            </div>
          </div>
          <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
            <div className={classNames(Styles.service__card)}>
              <Card1 img={img5} text={`偏鄉身障\n圓夢計畫`} to={`偏鄉身障圓夢計畫`} />
            </div>
          </div>
        </div> */}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default SocialService;
